import { RefObject } from 'react';
import { useClosestScrollContainer } from './useClosestScrollContainer';

export const useScrollIntoView = (
    ref: RefObject<HTMLElement | null>,
    options: { includeHidden: boolean } = { includeHidden: false }
) => {

    const scrollContainerRef = useClosestScrollContainer(ref, options);

    return () => {
        if (scrollContainerRef.current && ref.current) {

            const elementPosition = ref.current.getBoundingClientRect();
            const containerPosition = scrollContainerRef.current.getBoundingClientRect();
            const scrollPosition = {
                x: scrollContainerRef.current.scrollLeft,
                y: scrollContainerRef.current.scrollTop
            };

            scrollContainerRef.current.scroll({
                left: elementPosition.x - containerPosition.x + scrollPosition.x,
                top: elementPosition.y - containerPosition.y + scrollPosition.y,
                behavior: 'smooth'
            });
        }
    };
};